var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.labelClass,attrs:{"for":_vm.id}},[_vm._t("default"),_vm._v(" "),(_vm.required)?[_c('span',{staticClass:"font-bold text-red-600"},[_vm._v("*")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }